import { useDraggable } from "@dnd-kit/core"
import React, { type PropsWithChildren } from "react"
import { cn } from "../../styles/utils"

type DraggableProps = PropsWithChildren<{
  id: string
  disabled?: boolean
  data?: any
  className?: string
  draggingClassName?: string
}>

export const Draggable: React.FC<DraggableProps> = ({
  id,
  children,
  disabled = false,
  data,
  className = "",
  draggingClassName = "",
}) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id,
      disabled,
      data,
    })

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined

  const combinedClassName = cn(
    className,
    isDragging && draggingClassName,
    isDragging ? "z-[1000] opacity-80" : "z-[1]",
  )

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={combinedClassName}
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  )
}
